/**
 * @generated SignedSource<<d9ef54fe1f42d5cb160844a3a3c9205e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ContactChannelSelectorOptionsQuery$variables = {
  search?: string | null;
  skipChannels: boolean;
  skipContacts: boolean;
  skipUsers: boolean;
  userIdsToExclude: ReadonlyArray<string>;
};
export type ContactChannelSelectorOptionsQuery$data = {
  readonly viewer: {
    readonly channels?: ReadonlyArray<{
      readonly id: string;
      readonly isPrivate: boolean;
      readonly name: string;
    }>;
    readonly contacts?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly fullName: string;
          readonly groupSize: number | null;
          readonly id: string;
          readonly image: string;
          readonly isGroup: boolean;
          readonly user: {
            readonly email: string;
            readonly firstName: string;
            readonly id: string;
            readonly internalAttributes: {
              readonly oneOnOneWithViewer: {
                readonly archived: boolean | null;
                readonly id: string;
              } | null;
            } | null;
            readonly isActive: boolean;
            readonly isConfigured: boolean;
            readonly isGuest: boolean;
          } | null;
        } | null;
      } | null>;
    } | null;
    readonly users?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly internalAttributes: {
            readonly oneOnOneWithViewer: {
              readonly archived: boolean | null;
              readonly id: string;
            } | null;
          } | null;
          readonly isActive: boolean;
          readonly isConfigured: boolean;
          readonly isGuest: boolean;
        };
      }>;
    } | null;
  };
};
export type ContactChannelSelectorOptionsQuery = {
  response: ContactChannelSelectorOptionsQuery$data;
  variables: ContactChannelSelectorOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipChannels"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipContacts"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipUsers"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userIdsToExclude"
  }
],
v1 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v2 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v3 = [
  {
    "kind": "Literal",
    "name": "excludeExternal",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "excludeInactive",
    "value": true
  },
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "ranked",
    "value": true
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGroup",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupSize",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "oneOnOneWithViewer",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInternalAttributes",
  "kind": "LinkedField",
  "name": "internalAttributes",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "condition": "skipChannels",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludePersonal",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "NAME_ASC"
        },
        (v2/*: any*/)
      ],
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "channels",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v17 = [
  {
    "kind": "Literal",
    "name": "activeOnly",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "exclude",
    "variableName": "userIdsToExclude"
  },
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "isGuests",
    "value": false
  },
  (v2/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "UserInternalAttributes",
  "kind": "LinkedField",
  "name": "internalAttributes",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactChannelSelectorOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "skipContacts",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "ContactNodeConnection",
                "kind": "LinkedField",
                "name": "contacts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContactNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v16/*: any*/),
          {
            "condition": "skipUsers",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactChannelSelectorOptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "skipContacts",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "ContactNodeConnection",
                "kind": "LinkedField",
                "name": "contacts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContactNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContactNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v16/*: any*/),
          {
            "condition": "skipUsers",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v10/*: any*/),
                          (v5/*: any*/),
                          (v7/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c71e9c62c8240f274a23b262e6ae98d",
    "id": null,
    "metadata": {},
    "name": "ContactChannelSelectorOptionsQuery",
    "operationKind": "query",
    "text": "query ContactChannelSelectorOptionsQuery(\n  $search: String\n  $skipChannels: Boolean!\n  $skipContacts: Boolean!\n  $skipUsers: Boolean!\n  $userIdsToExclude: [ID!]!\n) {\n  viewer {\n    contacts(search: $search, first: 10, ranked: true, excludeInactive: true, excludeExternal: true) @skip(if: $skipContacts) {\n      edges {\n        node {\n          id\n          fullName\n          email\n          image\n          isGroup\n          groupSize\n          user {\n            id\n            email\n            firstName\n            isActive\n            isConfigured\n            isGuest\n            internalAttributes {\n              oneOnOneWithViewer {\n                id\n                archived\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n    channels(search: $search, excludePersonal: true, orderBy: NAME_ASC) @skip(if: $skipChannels) {\n      id\n      name\n      isPrivate\n    }\n    users(first: 10, search: $search, isGuests: false, activeOnly: true, exclude: $userIdsToExclude) @skip(if: $skipUsers) {\n      edges {\n        node {\n          id\n          email\n          firstName\n          fullName\n          image\n          isActive\n          isConfigured\n          isGuest\n          internalAttributes {\n            oneOnOneWithViewer {\n              id\n              archived\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d57e468daf3ab1a1b80cd01982a275c0";

export default node;
